/**
 * Map Tile Configuration
 * Shared Leaflet tile layer settings.
 *
 * CARTO basemaps (basemaps.cartocdn.com) now require an API key and serve
 * "API KEY REQUIRED" watermark tiles otherwise, so OpenStreetMap is the default.
 * Override with REACT_APP_MAP_TILE_URL / REACT_APP_MAP_TILE_ATTRIBUTION if needed.
 */

export const MAP_TILE_CONFIG = {
  URL: process.env.REACT_APP_MAP_TILE_URL || 'https://tile.openstreetmap.org/{z}/{x}/{y}.png',

  ATTRIBUTION: process.env.REACT_APP_MAP_TILE_ATTRIBUTION || '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',

  MAX_ZOOM: 19,
};
